import get from "lodash/get";
import React from "react";
import { withReactFinalTable } from "./FinalTableContext";

const defaultRender = (item, column) => get(item, column.key);

function TableBody({ columns = [], projection, map, onRowClick, rowClassName }) {
  if (!Array.isArray(projection)) {
    return <tbody />;
  }

  const className = onRowClick ? "has-action" : "";

  return (
    <tbody>
      {projection.map((id, index) => {
        const item = map[id];
        return (
          <tr
            key={`row-${item.id}`}
            onClick={event =>
              onRowClick && onRowClick(item, event, { total: projection.length, data: projection.map(i => map[i]) })
            }
            className={`${className} ${rowClassName ? rowClassName(item) : ""}`}>
            {columns.map(({ render = defaultRender, ...column }) => (
              <td key={column.key} style={column.style}>
                {column.key != "fileName" ? (
                  render(item, column, index)
                ) : item.documentProposalID ? (
                  <a href={`/file-ref/${item.documentProposalID.toString(16)}/${item.id.toString(16)}`}>
                    {render(item, column)}
                  </a>
                ) : (
                  render(item, column, index)
                )}
              </td>
            ))}
          </tr>
        );
      })}
    </tbody>
  );
}

export default withReactFinalTable(TableBody);
